import { useMemo } from 'react';
import { useWalletClient } from 'wagmi';

import { walletClientToSigner } from '../lib';

export const useSigner = (...args: Parameters<typeof useWalletClient>) => {
  const walletClient = useWalletClient(...args);

  return useMemo(() => {
    if (!walletClient.data) {
      return null;
    }

    return walletClientToSigner(walletClient.data);
  }, [walletClient.data]);
};
